import React from 'react'
import { CampaignMagnetScoreWrap, StyledHeading, ChartWrapper, AdditionalInfo } from './style'
import { ChartBarHorizontalCustom, MuiImage } from '../../../../../components'

const CampaignMagnetScore = ({
  endIcon,
  startIcon,
  bottomText = '',
  barData = [],
  rowData,
  heading = '',
  valueInPercent = false,
  maxPercentRatio = 100,
  showInside = true,
  maxWidth,
  valueAtRight,
  customPercentage,
  ...rest
}) => {

  return (
    <CampaignMagnetScoreWrap
      sx={{ marginLeft: heading ? '150px' : 0 }}
      className='campaignMagnetScore'
    >
      {heading && <StyledHeading>{heading}</StyledHeading>}
      <ChartWrapper>
        <ChartBarHorizontalCustom
          showInside={showInside}
          bottomText={bottomText}
          data={barData}
          valueInPercent={valueInPercent}
          endIcon={endIcon}
          customPercentage={customPercentage}
          // background='teal'
          // total={null}
          startIcon={startIcon}
          maxPercentRatio={maxPercentRatio}
          maxWidth={maxWidth}
          {...rest}
        />
      </ChartWrapper>
      {valueAtRight && <AdditionalInfo>{valueAtRight}%</AdditionalInfo>}
    </CampaignMagnetScoreWrap>
  )
}

export default CampaignMagnetScore
